var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.182 2.41663C18.115 2.41663 17.25 4.99099 17.25 8.16663H19.182C20.1131 8.16663 20.5787 8.16663 20.8668 7.84515C21.1551 7.52367 21.1049 7.10032 21.0046 6.25361C20.7397 4.01841 20.0237 2.41663 19.182 2.41663Z",
    stroke: "#423F5A",
    strokeWidth: 1.4375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 8.21863V18.3689C17.2501 19.8176 17.2501 20.5419 16.8073 20.827C16.0839 21.293 14.9655 20.3158 14.403 19.9611C13.9382 19.668 13.7059 19.5214 13.4479 19.513C13.1692 19.5038 12.9327 19.6444 12.4305 19.9611L10.5992 21.116C10.1052 21.4275 9.85826 21.5833 9.58341 21.5833C9.30857 21.5833 9.06156 21.4275 8.56758 21.116L6.73633 19.9611C6.27156 19.668 6.03917 19.5214 5.78126 19.513C5.50256 19.5038 5.26606 19.6444 4.76383 19.9611C4.20137 20.3158 3.08292 21.293 2.35945 20.827C1.91675 20.5419 1.91675 19.8176 1.91675 18.3689V8.21863C1.91675 5.48353 1.91675 4.11599 2.75882 3.26631C3.60088 2.41663 4.95617 2.41663 7.66675 2.41663H19.1667",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.25H13.4167",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 10.0834H5.75",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9792 10.9219C11.1854 10.9219 10.5417 11.485 10.5417 12.1797C10.5417 12.8744 11.1854 13.4375 11.9792 13.4375C12.7731 13.4375 13.4167 14.0007 13.4167 14.6954C13.4167 15.39 12.7731 15.9532 11.9792 15.9532M11.9792 10.9219C12.6051 10.9219 13.1376 11.2719 13.3349 11.7605M11.9792 10.9219V10.0834M11.9792 15.9532C11.3534 15.9532 10.8209 15.6032 10.6236 15.1146M11.9792 15.9532V16.7917",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.5062dd014bef1edae8e5e6bb96a952b1.svg";
export { ForwardRef as ReactComponent };